import Black from '../../assets/volcanobet/fonts/Roboto-Black.ttf';
import BlackItalic from '../../assets/volcanobet/fonts/Roboto-BlackItalic.ttf';
import Bold from '../../assets/volcanobet/fonts/Roboto-Bold.ttf';
import BoldItalic from '../../assets/volcanobet/fonts/Roboto-BoldItalic.ttf';

import ExtraLight from '../../assets/volcanobet/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '../../assets/volcanobet/fonts/Roboto-ThinItalic.ttf';
import Light from '../../assets/volcanobet/fonts/Roboto-Light.ttf';
import LightItalic from '../../assets/volcanobet/fonts/Roboto-LightItalic.ttf';
import Regular from '../../assets/volcanobet/fonts/Roboto-Regular.ttf';
import Italic from '../../assets/volcanobet/fonts/Roboto-Italic.ttf';
import SemiBold from '../../assets/volcanobet/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '../../assets/volcanobet/fonts/Roboto-MediumItalic.ttf';
import JungleAdventurer from '../../assets/volcanobet/fonts/JungleAdventurer.ttf';
import Caveman from '../../assets/volcanobet/fonts/Caveman.ttf';

export const fontFace = `
  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLight}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${Light}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 300;
    font-display: swap;
    src: url('${LightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Regular}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('${Italic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${Bold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url('${BoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${Black}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 900;
    font-display: swap;
    src: url('${BlackItalic}') format('opentype');
  }

  @font-face {
    font-family: 'Jungle Adventurer';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${JungleAdventurer}') format('opentype');
  }

  @font-face {
    font-family: 'Caveman';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Caveman}');
  }
`;
